import { render, staticRenderFns } from "./demo_requests.vue?vue&type=template&id=09f362ed&scoped=true&"
import script from "./demo_requests.vue?vue&type=script&lang=js&"
export * from "./demo_requests.vue?vue&type=script&lang=js&"
import style0 from "./demo_requests.vue?vue&type=style&index=0&id=09f362ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f362ed",
  null
  
)

export default component.exports